/**
 * MATAFOME — API DE GESTÃO DE ENTREGADORES E LOGÍSTICA DE DESPACHO
 */

import { safeApiFetch, getAuthHeaders } from './core.api';

export async function fetchCouriers() {
    const res = await safeApiFetch('/api/couriers', {
        method: 'GET',
        headers: getAuthHeaders()
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao buscar entregadores.');
    return data.couriers || [];
}

export async function createCourier(courierData) {
    const res = await safeApiFetch('/api/couriers', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(courierData)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao cadastrar entregador.');
    return data.courier;
}

export async function updateCourier(id, courierData) {
    const res = await safeApiFetch(`/api/couriers/${id}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(courierData)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao atualizar entregador.');
    return data.courier;
}

export async function deleteCourier(id) {
    const res = await safeApiFetch(`/api/couriers/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao remover entregador.');
    return data;
}

export async function toggleCourierStatus(id) {
    const res = await safeApiFetch(`/api/couriers/${id}/toggle-status`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({})
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao alternar status do entregador.');
    return data.courier;
}

export async function returnCourier(id) {
    const res = await safeApiFetch(`/api/couriers/${id}/return`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({})
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao registrar retorno do entregador.');
    return data.courier;
}

export async function reorderCouriersQueue(orderedIds) {
    const res = await safeApiFetch('/api/couriers/reorder-queue', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ orderedIds })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao reordenar roleta.');
    return data;
}

export async function fetchCourierSettlement(id, date) {
    const url = date ? `/api/couriers/${id}/settlement?date=${encodeURIComponent(date)}` : `/api/couriers/${id}/settlement`;
    const res = await safeApiFetch(url, {
        method: 'GET',
        headers: getAuthHeaders()
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao calcular acerto do entregador.');
    return data;
}

export async function settleCourierAccount(id, settlementData) {
    const res = await safeApiFetch(`/api/couriers/${id}/settle`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(settlementData)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao registrar acerto financeiro.');
    return data;
}

export async function fetchCourierSettlementHistory() {
    const res = await safeApiFetch('/api/couriers/settlements/history', {
        method: 'GET',
        headers: getAuthHeaders()
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao buscar histórico de acertos.');
    return data.history || [];
}

export async function dispatchOrderWithCourier(orderId, motoboyId) {
    const res = await safeApiFetch(`/api/orders/${orderId}/dispatch`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify({ motoboy_id: motoboyId })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao despachar pedido com motoboy.');
    return data.order;
}

// ----------------------------------------------------
// GRUPOS DE COMPLEMENTOS GLOBAIS
// ----------------------------------------------------
